<template>
  <div class="mm-page-main"  v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">銀行戶主管理</div>
      <div>
        <el-link @click="gotoruter('/AddBankHolder')" type="primary"><i class="el-icon-circle-plus"></i>添加銀行戶主</el-link>
      </div>
    </div>
    <search :form="form" @submit="getdata"></search>
    <div class="pagemain">
      <div v-loading="loading" class="pagetablebox">
        <el-table :data="data" border :header-cell-style="{background:'#FAFAFA'}">
          <el-table-column width="200" prop="code" label="戶主代號" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">戶主代號</div>
              <span>{{scope.row.code}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">姓名</div>
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="card" label="身份證號碼" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">身份證號碼</div>
              <span>{{scope.row.card}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardnum" label="持有卡數" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">持有卡數</div>
              <span>{{scope.row.cardnum}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="合計餘額(HKD)" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">合計餘額(HKD)</div>
              <span>{{scope.row.money}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="聯系電話" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">聯系電話</div>
              <span>{{scope.row.phone}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="備註" align="center" >
            <template slot-scope="scope">
              <div class="phonecel">備註</div>
              <span>{{scope.row.remarks}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="phonecel">操作</div>
              <el-button size="mini" @click="edit(scope.row)">編輯</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-bottom">
        <div>
          Total: {{pager.p_count}}個戶主
        </div>
        <div></div>
        <div>
          <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import search from "./components/SearchHolder.vue";

export default {
  components: {
    search
  },
  data () {
    return {
      loading:true,
      mso_id:0,
      form: {
        mso_id:0,
        name: '',
        phone: "",
        code: "",
        card: "",
        sortname:'code',
        orderby:'DESC',
      },
      data: [],
      page: 1,
      pagesize: 10,
      pager: [],
    };
  },
  methods: {
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    gotoruter (name) {
      this.$router.push(name)
    },
    getdata () {
      this.loading = true;
      let form = this.form;
      this.post('/api/bank/bank_holder', {
        page: this.page,
        pagesize: this.pagesize,
        ...form
      }).then((res) => {
        this.loading = false;
        this.data = res.info;
        this.pager = res.pager;
        this.page = 1;
      }).catch((err) => {
        this.data = [];
        this.pager = [];
        console.log(err)
      })
    },
    edit (row) {
      this.$router.push({
        name: '/EditBankHolder',
        path: '/EditBankHolder',
        params: {
          row: row
        }
      })
    },

  },
  created () {
    this.mso_id = this.sessionRead('mso_id');
    this.form.mso_id = this.sessionRead('mso_id');
    this.getdata();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.getdata();
      },
      deep: true
    },
  }
};
</script>
<style scoped>
.pagetablebox {
  padding: 20px 0;
}
.radio-group-box {
  display: flex;
  align-items: center;
}
</style>
